import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * 🔴 **字号必须 ≥16px**（在 styles.css 里全局兜了一道）。
 *    iOS Safari 在输入框字号小于 16px 时会自动放大整个页面，
 *    而且放大后不会缩回去 —— 用户以为页面坏了。
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-lg border border-input bg-background px-3 py-2 text-base",
        "placeholder:text-muted-foreground",
        "outline-none focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
